import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 11 6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 11 6\" id=\"icon-down\">\r\n<style type=\"text/css\">\r\n\t#icon-down .st0{fill:'';}\r\n</style>\r\n<g id=\"icon-down_Frame\">\r\n\t<path class=\"st0\" d=\"M5.5,6C5.4,6,5.2,6,5.1,5.9l-5-5C0,0.7,0,0.3,0.1,0.1s0.5-0.2,0.7,0l4.6,4.6l4.6-4.6c0.2-0.2,0.5-0.2,0.7,0\r\n\t\ts0.2,0.5,0,0.7l-5,5C5.8,6,5.6,6,5.5,6z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol